import { Typography } from '@mui/material'

// Types
import type { TypographyProps } from '@/types/components/atoms/typography'

const TitleTypographyAtom = (props: TypographyProps) => {
	// Props
	const { text } = props

	return (
		<Typography
			variant="h3"
			align="center"
			sx={{
				fontSize: { xs: 24, md: 40 },
				fontWeight: 700,
				lineHeight: 1.5,
				letterSpacing: -2
			}}
		>
			{text}
		</Typography>
	)
}

export default TitleTypographyAtom
